/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Table_Col_NoInputs */

const vi_await_table_col_no = /** @type {(inputs: Await_Table_Col_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STT`)
};

/**

* @param {Await_Table_Col_NoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_table_col_no = /** @type {((inputs?: Await_Table_Col_NoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Table_Col_NoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_table_col_no(inputs)
});